import { array, object, string } from 'yup';

import { getMaxLengthErrMsg, mandatoryErrMessage } from '@constants/validationConstants';
import { MAX_100_LENGTH } from '@constants/validationMessages';

const unitSchema = object({
	unit: string()
		.trim()
		.default('')
		.max(MAX_100_LENGTH, getMaxLengthErrMsg('Unit name', MAX_100_LENGTH))
		.required(mandatoryErrMessage('Approval unit name')),
	user: array()
		.nullable()
		.default(null)
		.min(1, mandatoryErrMessage('Approval user'))
		.required(mandatoryErrMessage('Approval user')),
});

export default unitSchema;
